import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["destroyField"]

    changed(event) {
        const value = event.target.value;
        const isBlank = !value || value === ""
        const destroyField = this.hasDestroyFieldTarget ? this.destroyFieldTarget : null

        const hasIdInput = this.element.querySelector('input[name*="[id]"]')

        if (hasIdInput && destroyField) {
            destroyField.value = isBlank ? "1" : "0"
        }
    }
}